import React from 'react'
import './loder.css'

function Loder() {
  return (
    <div className='loader'></div>
  )
}

export default Loder